import request from '@/utils/request'
import URL from '@/api/urlTranslator'

/**
 * 获取租户报关类型
 * @param params
 * @returns {AxiosPromise}
 */
export function getCustomsDeclarationTypeList(params) {
  return request({
    url: URL.mdm.basicData.customsDeclarationType,
    method: 'get',
    params
  })
}

/**
 * 获取平台报关类型
 * @param params
 * @returns {AxiosPromise}
 */
export function getCustomsDeclarationTypesByPlatform(params) {
  return request({
    url: URL.mdm.basicData.platformCustomsDeclarationType,
    method: 'get',
    params
  })
}

/**
 * 获取平台报关类型（系统新增弹框）
 * @param params
 * @returns {AxiosPromise}
 */
export function getAllCustomsDeclarationTypeTemplate(params) {
  return request({
    url: URL.mdm.basicData.customsDeclarationTypeTemplate,
    method: 'get',
    params
  })
}

/**
 * 保存报关类型
 * @param data
 * @returns {AxiosPromise}
 */
export function saveCustomsDeclarationType(data) {
  return request({
    url: URL.mdm.basicData.customsDeclarationType,
    method: data.uuid ? 'put' : 'post',
    data
  })
}

/**
 * 新增报关类型（系统新增）
 * @param data
 * @returns {AxiosPromise}
 */
export function addCustomsDeclarationTypeByPlatform(data) {
  return request({
    url: URL.mdm.basicData.platformCustomsDeclarationType,
    method: 'post',
    data
  })
}

/**
 * 新增，编辑时保存报关类型
 * @param data
 * @returns {AxiosPromise}
 */
export function saveCustomsDeclarationTypes(data) {
  return request({
    url: URL.mdm.basicData.customsDeclarationTypes,
    method: 'post',
    data
  })
}

/**
 * 删除报关类型
 * @returns {AxiosPromise}
 * @param params
 */
export function delCustomsDeclarationType(params) {
  return request({
    url: URL.mdm.basicData.customsDeclarationType,
    method: 'delete',
    params
  })
}
